import React from 'react'

import { CssIcon } from '@/components/CssIcon'


import { cls } from 'tagged-classnames-free';
export interface CollapseCornerProps {
  collapsed?: boolean
  onChange?: (collapsed: boolean) => void
}

const CollapseCorner: React.FC<CollapseCornerProps> = (props) => {
  const { collapsed, onChange } = props

  return (
    <div
      className={cls`
        text-f-text-secondary hover:text-f-text bg-f-bg-container border-f-border-active hover:bg-f-bg-hover absolute
        right-10 top-0 flex -translate-y-full cursor-pointer items-center rounded-t border-x border-t
        px-2 py-[2px] transition-all
      `}
      onClick={() => {
        onChange?.(!collapsed)
      }}
    >
      <CssIcon
        className={`${collapsed ? 'i-cus--tad-up-line-duotone' : 'i-cus--tad-down-line-duotone'} size-3`}
      />
    </div>
  )
}

export default CollapseCorner
